import {Pages} from 'shared/config/model/pages';
import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {Helmet} from 'react-helmet-async';
import {generatePath} from 'react-router-dom';
import {i18n} from '@lingui/core';

import BackButton from 'shared/ui/IconButton/BackButton';
import BoxTransparent from 'shared/ui/Box/BoxTransparent/BoxTransparent';

import {t} from '@lingui/core/macro';

import MetricsDashboard from './MetricsDashboard/MetricsDashboard';
import IncidentTypesChart from './IncidentTypesChart/IncidentTypesChart';

import styles from './Reports.module.scss';

const Reports: React.FC = () => {

    return (
        <>
            <div className={styles.mobileHeader}>
                <BackButton
                    to={generatePath(AppUrls.SETTINGS)}
                    text="Назад"
                />
                <h3>{i18n._(Pages.ANALYTICS)}</h3>
            </div>
            <BoxTransparent>
                <Helmet>
                    <title>
                        {`${t`Аналитика сервиса`} | ${t`Overseer`}`}
                    </title>
                </Helmet>
                <div className={styles.header}>
                    <h3>{i18n._(Pages.ANALYTICS)}</h3>
                </div>
                <MetricsDashboard />
                <IncidentTypesChart />
            </BoxTransparent>
        </>
    );
};

export default Reports;